import React, { useContext, useRef, useState } from 'react'
import { Button, ListMenu, ListMenuButton, Modal, Popover, Spacer,
   TabMenu, TabMenuButton, Text, View } from 'oio-react'
import { Route, useHistory, useParams, useRouteMatch } from 'react-router-dom'
import MoreIcon from 'assets/icons/more'
import uiConstants from 'config/constants/ui'
import ContentListSearchBox from 'src/components/Settings/ContentListSearchBox'
import RoleImport from 'src/components/Settings/RoleImport'
import RoleInvite from 'src/components/Settings/RoleInvite'
import RoleUserList from 'src/components/Settings/RoleUserList'
import { initiativeSettingsPeopleRoleUrl,
   initiativeSettingsReportsUrl } from 'src/components/utils/urls'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'
import { useCreateReport } from 'src/graphql/hooks'

const InitiativeSettingsPeopleRole = () => {
   const popoverButton = useRef()
   const [popoverIsOpen, setPopoverIsOpen] = useState(false)
   const [modalIsOpen, setModalIsOpen] = useState(true)
   const [searchBoxValue, setSearchBoxValue] = useState('')
   const [activeSearchValue, setActiveSearchValue] = useState('')

   const history = useHistory()
   const match = useRouteMatch()
   const { roleId, roleStatus } = useParams()

   const { createReport } = useCreateReport()
   const { initiative } = useContext(InitiativeHierarchyContext)

   // TODO: Improve this later
   const reportsUrl = initiativeSettingsReportsUrl()
   const role = initiative.roles.find(r => r.id === roleId)
   const roleBaseUrl = `${initiativeSettingsPeopleRoleUrl(role.id)}`
   const roleBasePath = `${initiativeSettingsPeopleRoleUrl(':roleId')}`

   const links = [{
      name: 'Active',
      badgeNumber: role.numActiveUsers,
      linkTo: initiativeSettingsPeopleRoleUrl(role.id),
      linkExact: true
   }, {
      name: 'Invited',
      badgeNumber: role.numInvitedUsers,
      linkTo: `${initiativeSettingsPeopleRoleUrl(role.id)}/invited`
   }]

   if (role.numInactiveUsers) {
      links.push({
         name: 'Inactive',
         badgeNumber: role.numInactiveUsers,
         linkTo: `${initiativeSettingsPeopleRoleUrl(role.id)}/inactive`
      })
   }

   if (role.numDeclinedUsers) {
      links.push({
         name: 'Declined',
         badgeNumber: role.numDeclinedUsers,
         linkTo: `${initiativeSettingsPeopleRoleUrl(role.id)}/declined`
      })
   }

   const handleExportToCsv = () => {
      // Note: we don't wait for the report generation to finish,
      // otherwise this would just hang for a while, especially
      // if the reports are large. We redirect to reports listing
      // right away.
      // TODO: Better error handling, though the ReportList should
      // show if report generation crapped out.
      createReport({
         roleId,
         initiativeId: initiative.id,
         type: 'InitiativePeople'
      })

      history.push(reportsUrl)
   }

   const handleInvitationSuccess = () => {
      setModalIsOpen(false)
      setSearchBoxValue('')
      setActiveSearchValue('')
   }

   return (
      <View
         float="left"
         width="100%"
         backgroundColor="#fff"
         borderRadius="6px"
         padding="6px">
         <View
            display="flex"
            justifyContent="space-between"
            padding="12px 18px 0px 18px">
            <Text size="4" weight="medium">
               {`${initiative.type.nameSingular} ${role.name}`}
            </Text>
            <View flex="0 0 auto">
               <View
                  ref={popoverButton}
                  position="relative"
                  display="flex"
                  alignItems="center">
                  <Button
                     linkTo={`${initiativeSettingsPeopleRoleUrl(role.id)}/invited/new`}
                     width="72px"
                     name="Invite"
                     color="#f7b77c"
                     textColor="#111"
                     textWeight="bold"
                     size="xs"
                     rounded
                  />
                  <Spacer size="1" orientation="vertical" />
                  <Button
                     onClick={() => setPopoverIsOpen(true)}
                     width="24px"
                     color="#f7b77c"
                     textColor="#111"
                     textWeight="bold"
                     size="xs"
                     rounded>
                     <MoreIcon width="18px" height="18px" />
                  </Button>
                  <Popover
                     anchorElement={popoverButton.current}
                     anchorOriginHorizontal="right"
                     anchorOriginVertical="top"
                     borderRadius="6px"
                     width="150px"
                     onBodyClick={() => setPopoverIsOpen(false)}
                     open={popoverIsOpen}>
                     <View
                        float="left"
                        width="100%"
                        borderRadius="6px"
                        backgroundColor="#fff"
                        boxShadow="6px 6px 30px rgba(0,0,0,0.1)">
                        <ListMenu buttonSize="md">
                           {/* TODO: STEVE THE FIRST BUTTON DOESNT WORK */}
                           <ListMenuButton
                              onClick={handleExportToCsv}
                              name="Export to .csv"
                           />
                           <ListMenuButton
                              linkTo={`${initiativeSettingsPeopleRoleUrl(role.id)}/import`}
                              name="Import from .csv"
                           />
                        </ListMenu>
                     </View>
                  </Popover>
               </View>
            </View>
         </View>
         <TabMenu
            backgroundColor="#fff"
            buttonPaddingHorizontal="0px"
            buttonSpacing="24px"
            paddingHorizontal="18px">
            {links.map(link => (
               <TabMenuButton
                  key={link.name}
                  name={link.name}
                  badgeNumber={link.badgeNumber}
                  linkTo={link.linkTo}
                  linkExact={link.linkExact}
               />
            ))}
         </TabMenu>
         <View width="100%">
            <ContentListSearchBox
               value={searchBoxValue}
               onChange={setSearchBoxValue}
               onSubmit={setActiveSearchValue}
            />
            <RoleUserList
               roleId={roleId}
               searchValue={activeSearchValue || null}
               status={roleStatus}
               targetId={initiative.id}
               targetType="initiative"
            />
         </View>
         <Route
            path={`${roleBasePath}/import/:batchImportId?`}
            render={() => (
               <Modal
                  borderRadius="9px"
                  width="100%[a-b] 90%[c] 900px[d-f]"
                  height="100%[a-b] 90%[c] 80%[d-f]"
                  onCloseComplete={() => {
                     history.push(match.url)
                     setModalIsOpen(true)
                  }}
                  onCloseTrigger={() => setModalIsOpen(false)}
                  open={modalIsOpen}
                  zIndex={uiConstants.zIndexes.tmpSettingsModal}>
                  <RoleImport
                     baseUrl={`${roleBaseUrl}/import`}
                     onCloseButtonClick={() => setModalIsOpen(false)}
                     targetType="initiative"
                  />
               </Modal>
            )}
         />
         <Route
            path={`${roleBaseUrl}/invited/new`}
            render={() => (
               <Modal
                  borderRadius="6px"
                  width="100%[a-b] 330px[c-f]"
                  onCloseComplete={() => {
                     history.push(match.url)
                     setModalIsOpen(true)
                  }}
                  onCloseTrigger={() => setModalIsOpen(false)}
                  open={modalIsOpen}
                  zIndex={uiConstants.zIndexes.tmpSettingsModal}>
                  <RoleInvite
                     onCloseButtonClick={() => setModalIsOpen(false)}
                     onInvite={handleInvitationSuccess}
                     roleId={role.id}
                     roleName={role.name}
                     targetId={initiative.id}
                     targetType="initiative"
                  />
               </Modal>
            )}
         />
      </View>
   )
}

export default InitiativeSettingsPeopleRole
